module.exports = __webpack_public_path__ + "img/10重合同守信用企业证书1.c2cdc90b.png";